// application/useVisitaCatalogos.js  (catálogos del formulario: ciclos, productores del ciclo y parcelas del productor elegido)
import { catalogosRepository } from '../../shared/infrastructure/catalogos.repository';
import { useCatalogo } from '../../shared/application/useCatalogo';
import { cicloActivoId } from '../../shared/domain/ciclo';

// `idCuenta`: productor elegido (null => sin parcelas). Las parcelas se piden solo de ese productor (caché por cuenta).
// `idCiclo`: ciclo de la visita (null al crear => ciclo activo, el mismo que propone `conCicloPorDefecto`).
// Los productores se piden hasta conocer los ciclos.
export const useVisitaCatalogos = ({ idCooperativa, idCiclo = null, idCuenta = null, catalogos = catalogosRepository } = {}) => {
  const ciclos = useCatalogo(() => catalogos.ciclos(idCooperativa), [catalogos, idCooperativa]);
  const ciclosReady = ciclos.status === 'success' || ciclos.status === 'error';
  const cicloEfectivo = idCiclo !== null ? idCiclo : cicloActivoId(ciclos.data);
  const productores = useCatalogo(() => (ciclosReady ? catalogos.productores(cicloEfectivo) : []), [catalogos, ciclosReady, cicloEfectivo]);
  const parcelas = useCatalogo(() => catalogos.parcelasDeProductor(idCuenta), [catalogos, idCuenta]);

  return {
    ciclos: ciclos.data,
    productores: productores.data,
    parcelas: parcelas.data,
    ciclosReady,
    productoresLoading: productores.status === 'loading',
    parcelasLoading: parcelas.status === 'loading',
    // Solo bloquea el formulario lo ligero; productores y parcelas muestran su propio "Cargando..." en el campo.
    loading: ciclos.status === 'loading',
  };
};

export default useVisitaCatalogos;
